export const extractTableData = (htmlContent: string): Array<Array<string>> => {
	if (typeof window === 'undefined') {
		// DOMParser is unavailable in SSR
		console.error('DOMParser is not available on the server.');
		return [];
	}

	// Parse the HTML content in the browser
	const parser = new DOMParser();
	const doc = parser.parseFromString(htmlContent, 'text/html');

	// Find the first table in the content
	const table = doc.querySelector('table');
	if (!table) return []; // Return an empty array if no table is found

	// Extract rows and cells
	const rows = Array.from(table.rows).map((row) =>
		Array.from(row.cells).map((cell) => cell.textContent?.trim() || '')
	);

	return rows;
};

export const renderTableFromData = (tableData: Array<Array<string>>) => {
	if (tableData.length === 0) return null; // No table data

	return (
		<div className='table-responsive mt-5'>
			<table className='table-auto border-collapse'>
				<thead>
					<tr>
						{tableData[0].map((header, index) => (
							<th key={index} className='p-2'>
								{header}
							</th>
						))}
					</tr>
				</thead>

				<tbody>
					{tableData.slice(1).map((row, rowIndex) => (
						<tr key={rowIndex}>
							{row.map((cell, cellIndex) => (
								<td key={cellIndex} className='p-2'>
									{cell}
								</td>
							))}
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};
